import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { Base, ReverLoading } from '@itsrever/design-system'
import { useDailyReturns, useReturnMetrics } from '@/application/queries'
import { DailyReturnsChart } from '@/ui/components/analytics-components/daily-returns-chart'
import { formatPercent } from '@/utils/format'

const { Badge, Card, InfoTooltip } = Base

export function MainChart() {
  const { t, i18n } = useTranslation()

  const startDate = moment().subtract(1, 'M').format('YYYY-MM-DD')
  const endDate = moment().format('YYYY-MM-DD')

  const { returnMetrics, loadingReturnMetrics, returnMetricsFailed } =
    useReturnMetrics(startDate, endDate)

  const {
    totalItemsReturnedByDay,
    returnDays: dates,
    loadingDailyReturns
  } = useDailyReturns(startDate, endDate)

  if (returnMetricsFailed) {
    return (
      <Card className="flex h-80 items-center justify-center p-7">
        <p className="text-sm">Something went wrong. Please try again.</p>
      </Card>
    )
  }

  if (loadingReturnMetrics || loadingDailyReturns || !returnMetrics) {
    return (
      <Card className="flex h-80 items-center justify-center p-7">
        <ReverLoading />
      </Card>
    )
  }

  return (
    <Card className="flex h-80 flex-col overflow-hidden">
      <div className="flex justify-between gap-4 px-7 py-6">
        <div className="flex gap-12">
          <div>
            <p>{t('main_chart.returns')}</p>
            <div className="mt-2 flex">
              <h3 className="font-bold">
                {returnMetrics.totalReturns.toLocaleString(i18n.language)}
              </h3>
            </div>
          </div>
          <div>
            <div className="flex items-center">
              <p className="mr-1">{t('main_chart.rdv')}</p>
              <InfoTooltip
                label={t('main_chart.about_rdv')}
                content={t('main_chart.rdv_description')}
              />
            </div>
            <div className="mt-2 flex">
              <h3 className="font-bold">
                {formatPercent(returnMetrics.rdvPercentage, i18n.language)}
              </h3>
            </div>
          </div>
          <div>
            <div className="flex items-center">
              <p className="mr-1">{t('main_chart.sales')}</p>
              <InfoTooltip
                label={t('main_chart.about_sales')}
                content={t('main_chart.sales_description')}
              />
            </div>
            <div className="mt-2 flex">
              <h3 className="font-bold">{returnMetrics.rdvAmount}</h3>
            </div>
          </div>
        </div>
        <Badge className="h-fit shrink-0">
          {t('main_chart.returns_period')}
        </Badge>
      </div>
      <div className="size-full flex-1">
        <DailyReturnsChart
          variant="light"
          values={totalItemsReturnedByDay}
          days={dates}
        />
      </div>
    </Card>
  )
}
